<div class="flex items-center gap-2 custom-form" [formGroup]="dateForm">
  <div class="flex w-full min-w-[180px] cursor-pointer" (click)="openDatePicker($event)">
    <mat-form-field
      class="flex-1 [&_input]:pointer-events-none mat-mdc-form-field-type-mat-date-picker"
      [class.active-datepicker]="datePicker?.opened"
    >
      <mat-label>
        {{ dateLabel() || ('pages.campaignForm.sections.basics.startDatePlaceholder' | translate) }}
      </mat-label>
      <input readonly matInput [value]="dateForm.get('date')?.value | date: 'dd.MM.yyyy HH:mm'" />

      <div matSuffix class="flex items-center gap-1">
        <app-icon src="icons/chevron-down.svg" [size]="20" />
      </div>
      <mat-datepicker #datePicker></mat-datepicker>

      <div class="opacity-0 absolute pointer-events-none">
        <input matInput [matDatepicker]="datePicker" formControlName="date" />
      </div>
    </mat-form-field>
  </div>
</div>
